<script setup lang="ts">
import { BellIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import { ref } from 'vue'

const drawerOpen = ref(false)
const notifying = ref(true)
</script>

<template>
  <div>
    <button
      class="relative flex h-8.5 w-8.5 items-center justify-center border border-stroke bg-white text-slate-700 hover:text-primary"
      @click="
        () => {
          drawerOpen = true
          notifying = false
        }
      ">
      <span :class="!notifying && 'hidden'" class="absolute -top-0.5 right-0 z-1 h-2 w-2 bg-meta-1">
        <span class="absolute -z-1 inline-flex h-full w-full animate-ping bg-meta-1 opacity-75"></span>
      </span>
      <BellIcon class="h-[18px] w-[18px]" />
    </button>

    <Teleport to="body">
      <div v-show="drawerOpen" class="fixed inset-0 z-[12000]">
        <div class="absolute inset-0 bg-black/50" @click="drawerOpen = false"></div>

        <aside class="absolute right-0 top-0 h-full w-full max-w-2xl border-l border-stroke bg-white shadow-2xl">
          <header class="flex items-center justify-between border-b border-stroke px-6 py-4">
            <h5 class="text-lg font-semibold text-slate-800">Notificações</h5>
            <button class="border border-stroke p-2 text-slate-600 hover:bg-slate-100" @click="drawerOpen = false">
              <XMarkIcon class="h-5 w-5" />
            </button>
          </header>

          <div class="flex h-[calc(100%-64px)] items-center justify-center px-6 py-4">
            <div class="h-full w-full border border-dashed border-stroke bg-slate-50"></div>
          </div>
        </aside>
      </div>
    </Teleport>
  </div>
</template>
